import { SvgIcon } from '@mui/material';
import FireExtinguisherIcon from '@mui/icons-material/FireExtinguisher';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import AirIcon from '@mui/icons-material/Air';
import SensorsIcon from '@mui/icons-material/Sensors';
import WaterDropIcon from '@mui/icons-material/WaterDrop';
import WbIridescentIcon from '@mui/icons-material/WbIridescent';
import CampaignIcon from '@mui/icons-material/Campaign';
import SmokeFreeIcon from '@mui/icons-material/SmokeFree';
import WaterIcon from '@mui/icons-material/Water';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import MapIcon from '@mui/icons-material/Map';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ShowerIcon from '@mui/icons-material/Shower';

export const inventoryCategoryIconMap = {
  'fire-extinguisher': FireExtinguisherIcon,
  'meeting-room': MeetingRoomIcon,
  air: AirIcon,
  sensors: SensorsIcon,
  'water-drop': WaterDropIcon,
  'wb-iridescent': WbIridescentIcon,
  campaign: CampaignIcon,
  'smoke-free': SmokeFreeIcon,
  water: WaterIcon,
  'exit-to-app': ExitToAppIcon,
  'monitor-heart': MonitorHeartIcon,
  'medical-services': MedicalServicesIcon,
  map: MapIcon,
  'health-and-safety': HealthAndSafetyIcon,
  visibility: VisibilityIcon,
  shower: ShowerIcon,
} satisfies Record<string, typeof SvgIcon>;

export type InventoryCategoryIconName = keyof typeof inventoryCategoryIconMap;
